export default __webpack_public_path__ + "static/media/warning--double-turn-first-left--g1.be7aa3be.png";